import { setDefaultValues, setToTopDimIds } from '../dimensionUtils'
export function createDefaultPivotConfig(dimensions) {
  let chart = 'bar-chart'
  let dimOptions = dimensions.dimensionOptions
  let metas = dimensions.dimensionMetas

  let pivotConfig
  pivotConfig = {
    dimensions: Object.keys(dimOptions).map(key => {
      let type = metas[key].type
      let role = type === 'time' ? 'columns' : type === 'location' ? 'rows' : 'filters'
      if (type === 'time') {
        role = 'filters'
      }
      return {
        id: key,
        role: role,
      }
    }),
  }

  Object.keys(metas).forEach(key => {
    if (metas[key].typeOptions.length > 0) {
      pivotConfig.dimensions.push({
        id: key + '_type',
        role: 'types',
      })
    }
  })

  setDefaultValues(pivotConfig.dimensions, dimOptions, metas, chart)

  let rowsDim = pivotConfig.dimensions.find(d => d.role === 'rows')
  if (metas[rowsDim.id].type === 'location' && rowsDim.values.length === 1) {
    let filterDims = pivotConfig.dimensions.filter(d => d.role === 'filters')
    // repensar seguro...
    let xCandidate = filterDims.find(d => metas[d.id].type !== 'time') || filterDims[0]
    xCandidate.role = 'rows'
    rowsDim.role = 'filters'
    // if (filterDims.length > 0) {
    //   filterDims = filterDims.slice(0, 2)
    //   filterDims.forEach(d => (d.role = 'rows'))
    //   rowsDim.role = 'filters'
    // } else {
    //   let colsDim = pivotConfig.dimensions.find(d => d.role === 'columns')
    //   rowsDim.role = 'columns'
    //   colsDim.role = 'rows'
    // }
    setDefaultValues(pivotConfig.dimensions, dimOptions, metas, chart)
  }

  //RELLENAMOS ROWS Y COLS

  // let rowsDims = pivotConfig.dimensions.filter(d => d.role === 'rows')
  let filetrsDims = pivotConfig.dimensions.filter(d => d.role === 'filters')
  let colsDims = pivotConfig.dimensions.filter(d => d.role === 'columns')

  let toCols

  if (colsDims.length === 1 && colsDims[0].values.length === 1) {
    colsDims[0].role = 'filters'
    toCols = filetrsDims.slice(0, 1) //  [filetrsDims[0]]
    toCols.forEach(d => (d.role = 'columns'))
    setDefaultValues(pivotConfig.dimensions, dimOptions, metas, chart)
  }

  setToTopDimIds(pivotConfig, metas)

  setDefaultValues(pivotConfig.dimensions, dimOptions, metas, chart)

  return pivotConfig
}
function recursiveFindGeoAvaliableOptions(locDim, founded) {
  let stFound = founded ? founded : false
  const avaliableOp = [
    'districte',
    'distrito',
    'district',
    'barri',
    'barrio',
    'neighborhood',
    'àrea estadística bàsica',
    'área estadística básica',
    'basic statistical area',
    'secció censal',
    'sección censal',
    'census district',
  ]
  if (!stFound) {
    locDim.forEach(element => {
      if (avaliableOp.indexOf(element.type.toLowerCase()) !== -1) stFound = true
      else {
        if (element.values) {
          stFound = recursiveFindGeoAvaliableOptions(element.values, stFound)
        }
      }
    })
    return stFound
  } else return true
}

export function hasMapRepresentation(dataCard) {
  let locDim = dataCard?.dims?.find(dim => dim.type === 'location')
  if (!locDim) return false
  else return recursiveFindGeoAvaliableOptions(locDim.values)
}

export default {
  createDefaultPivotConfig,
  hasMapRepresentation,
}
